import React from 'react';

import { UxContext } from '@client/context/UxContext';
import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import lediumApi from '@client/utils/lediumApi';
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent';
import { Button } from '@mui/material';

const DmxChannelTestButton = () => {
    const { handleSnackbar } = React.useContext(UxContext)!;
    const {
        pageState: { formData }
    } = usePageStore();
    let channelTestLock = false;

    async function testChannel() {
        if (!channelTestLock) {
            channelTestLock = true;
            const result = await lediumApi.get(`lightChannels/testDmx/${formData.channel}/${formData.resolution}`);
            channelTestLock = false;
            if (result) {
                handleSnackbar({ message: i18n('dmx_test_sent') as string, severity: 'info' });
            } else {
                handleSnackbar({ message: i18n('dmx_test_failed') as string, severity: 'error' });
            }
        }
    }

    if (!formData.channel) {
        return null;
    }
    return (
        <Button sx={{ marginTop: '8px', marginLeft: '8px' }} variant="contained" onClick={testChannel} startIcon={<WbIncandescentIcon />}>
            {i18n('test_channel')}
        </Button>
    );
};

export default DmxChannelTestButton;
